import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const Header = () => {
  return <header className="bg-white" data-id="element-16957" data-mp="2dluqsp1k3jss">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-16958" data-mp="2do7ihtx498j1"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-16959" data-mp="2ik5zgwg47o9f">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-16960" data-mp="2nllot0pbsgxm">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-16961" data-mp="2rmf81grtp7k6">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-16962" data-mp="2wjnu3sg3dvqp">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex justify-start mb-3" data-id="element-16963" data-mp="36a0bxcwivat5">
          <div className="text-xs text-gray-400 font-sans" data-id="element-16964" data-mp="36cwb14k3w5j6">Advertorial 1</div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-16965" data-mp="3b81vs01rve5o">
          <div className="text-left" data-id="element-16966" data-mp="2wkkz5e59tq4a">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-16967" data-mp="2wm5sj0fun30k">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-16968" data-mp="3fd6orgpl4kgf">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-16969" data-mp="35k805yu38twt">
        <div className="max-w-4xl mx-auto" data-id="element-16970" data-mp="30mzfnrlgwdse">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-16971" data-mp="30lwnlgces5aw">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-16972" data-mp="3tavcqxey87pp">
            Nurse Practitioner Investigates: Do 'Earthing' Bed Sheets Actually
            Work, or Is It Another Wellness Scam?
          </h1>
          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-16973" data-mp="1wequi9d64v6e">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-16974" data-mp="1hn8iemnfjksb">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5V1KLd9diP6p4Lsag55oX2/YYkJmGMhE_ELwA2hWH_Ii.jpg" alt="Patricia Chen" className="w-full h-full object-cover" data-id="element-16975" data-mp="1mkrxforyc1lb" />
            </div>
            <div className="flex-1" data-id="element-16976" data-mp="1cmkifbh83tly">
              <div className="flex items-center" data-id="element-16977" data-mp="ypfgnnojlgwi">
                <div className="font-medium text-gray-900 text-lg" data-id="element-16978" data-mp="yqqktolwgqo5">
                  By Patricia Chen, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-16979" data-mp="2t2x5rf4liltn">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-16980" data-mp="2t0u7k7tahmdu" />
                  <span className="text-xs ml-1 font-medium" data-id="element-16981" data-mp="2y29q9t7zvgt2">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-16982" data-mp="mfg48nv31rfx">
                Former Head of Integrative Medicine, Cedar Sinai Medical Center
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-16983" data-mp="w47r4hladljz">
                <div className="flex items-center mr-4" data-id="element-16984" data-mp="w6kdd6y2ui2u">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-16985" data-mp="rcpx6dhokl8i" />
                  <span data-id="element-16986" data-mp="1555tkvg2tl0g">11 min read</span>
                </div>
                <div className="flex items-center" data-id="element-16987" data-mp="153l3bi0soo8e">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-16988" data-mp="106ktqx4ql3cj" />
                  <span data-id="element-16989" data-mp="105t6qap7gdxv">24,867 views</span>
                </div>
              </div>
            </div>
          </div>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-16990" data-mp="1f0zfh5foqquw">
            After 30 years in medicine, I've seen every "miracle cure" come and
            go. So when I found out about "earthing" or "grounding" bed sheets,
            I decided to run a 6-month investigation. What I discovered will
            save you hundreds of dollars – and might actually change your sleep.
          </p>
          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-16991" data-mp="27wgvur9xobkd">
            <div className="mb-1 flex items-center" data-id="element-16992" data-mp="2cxmluhc7lkq7">
              <span className="font-medium mr-2" data-id="element-16993" data-mp="2gyyekvqdqm2m">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-16994" data-mp="1k9qrvke0y6x4">
              <span className="font-medium mr-2" data-id="element-16995" data-mp="1p70opl3qtkuz">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-16996" data-mp="15hyom6ri8jbr">
        <div className="max-w-4xl mx-auto" data-id="element-16997" data-mp="y0aay6h1u9m5">
          <div className="sm:flex items-center" data-id="element-16998" data-mp="xz8oz6yhw2pn">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-16999" data-mp="t0xeqv4afq6w">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" alt="Patricia Chen, RN, MSN in hospital corridor" className="w-full rounded-lg shadow-md" data-id="element-17000" data-mp="sykx6j2fzhud" />
            </div>
            <div className="sm:w-2/3" data-id="element-17001" data-mp="f0ml5kblfxi1">
              <p className="text-sm text-gray-700 mb-2" data-id="element-17002" data-mp="f1o6qiq8k2e0">
                <span className="font-bold" data-id="element-17003" data-mp="aafyvr4k0p2y">Patricia Chen, RN, MSN</span> has
                spent three decades in clinical practice specializing in
                integrative medicine approaches. As the former Head of
                Integrative Medicine at Cedar Sinai Medical Center, she has
                evaluated hundreds of wellness products and alternative
                treatments throughout her career.
              </p>
              <p className="text-sm text-gray-700" data-id="element-17004" data-mp="3ni0vtnobupwf">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping patients make informed
                health decisions based on scientific testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;